<template lang="pug">
.login(@keydown.enter="login")
  .login__content
    .login__logo
      img(src="@/umcc/assets/login_logo.png")
    .login__form
      .login__account
        i.iconfont.icon-zhanghao1
        input(
          type="text"
          v-model="account"
          :placeholder="$t('请输入邮箱')"
          @keydown.enter="onKeydown"
        )
      .login__password
        i.iconfont.icon-mima
        input(
          type="password"
          v-model="password"
          @keydown.enter="onKeydown"
        )
      .login__forget-password
        el-checkbox( v-model="rememberMe" ) {{ $t('记住登录状态') }}
        span(
          style="color: #c9ccd2; cursor: pointer;"
          @click="$router.push('/forget-password')"
        ) {{ $t('忘记密码') }}
      .login__button(@click="login") {{ $t('登入') }}
</template>

<script>
import axios from 'axios'
import { format4backend } from '@/umcc/util'
import db from '@/umcc/db'

export default {
  data () {
    return {
      account: '',
      password: '',
      loading: false,
      rememberMe: false
    }
  },
  methods: {
    onKeydown (e) {
      if (e.keyCode !== 13) {
        e.stopPropagation()
      }
    },
    login () {
      if (!this.validateInfo()) return
      this.loading = true
      axios
        .post(
          '/signin',
          format4backend({
            username: this.account,
            password: this.password,
            rememberMe: String(this.rememberMe),
            return_type: 'json',
            product_version: 'v5.6.0'
          })
        )
        .then(data => {
          this.loading = false
          if (data.is_authed) {
            data.user.redirect_url = data.redirect_url
            // data.user.company_name = 'Mccann'
            this.$store.commit('common/setUser', data.user)
            if (data.first_login) this.$store.commit('common/setVersionRemind', true)

            if (db.from_url) {
              window.location.href = db.from_url
              db.from_url = null
            } else {
              this.$router.push(data.redirect_url)
            }
          } else {
            this.$message.error(data.error_msg)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    validateInfo () {
      if (this.loading) return false
      if (this.account === '' || this.password === '') {
        this.$message.error(this.$t('请输入账号或密码'))
        return false
      }
      return true
    }
  }
}
</script>

<style lang="stylus">
.login
  display flex
  justify-content center
  height 100vh
  background-image url("./assets/bg.png")
  background-repeat no-repeat
  background-size 100vw 100vh

.login__logo
  display flex
  justify-content center
  align-items center
  img
    width 270px

.login__content
  margin-top 160px

.login__form
  margin-top 90px

.login__account
.login__password
  display flex
  align-items center
  width: 386px
  height: 60px
  border-radius: 6px
  box-shadow: 0 0 12px 0 rgba(167, 181, 204, 0.38)
  background-color: #ffffff
  > i
    font-size 26px
    padding 0 24px
    color #c9ccd2
  > input
    width 280px
    letter-spacing 1px
    border none
    font-size 18px
    height 30px
    line-height 30px
    background-color transparent
    outline none
    &::placeholder
      color #c9ccd2
    &:-webkit-autofill
      transition background-color 5000s ease-in-out 0s
    &:-webkit-autofill::first-line
      font-size: 18px;
      letter-spacing 1px
.login__account
  margin-bottom 38px

.login__password
  margin-bottom 18px

.login__button
  width: 386px
  height: 60px
  border-radius: 6px
  background-color: #3370d2
  display flex
  justify-content center
  align-items center
  color white
  cursor pointer
  font-size 24px

.login__forget-password
  display flex
  justify-content space-between
  margin-bottom 42px
  .el-checkbox
    color #c9ccd2
</style>
